import { VideoLayout } from '@core/types';
import { PresentationContentProps } from './types';

export const PresentationContent = ({ children, isLandscape, isMobile, videoLayout }: PresentationContentProps) => (
    <div
        id="presentation"
        className={`relative col-start-1 min-w-0 ${isMobile ? (isLandscape ? 'row-start-1 min-h-0' : 'row-start-2 min-h-[30dvh]') : (videoLayout === VideoLayout.Classic ? 'row-start-2 min-h-0 max-h-[calc(50dvh-calc(var(--viewer-info-space)/2))]' : 'row-start-1 min-h-0 max-h-[calc(100dvh-var(--viewer-info-space))]')}`}
    >
        {children}
    </div>
);
